import React from 'react';
import EgresosUI from '../../Admin/Egresos/EgresosUI';

const EgresosContabilidadUI = () => {
  return <EgresosUI apiBasePath="/api/contabilidad" allowEditDelete={false} />;
};

export default EgresosContabilidadUI;